(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("invoiceDetails", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/settings/subscription/invoiceDetailsView.html",
            controller: ["$state", "subscriptionResource", "messageService", "$translate", "currencyService", InvoiceDetailsCtrl],
            controllerAs: "vm"
        };
        function InvoiceDetailsCtrl($state, subscriptionResource, messageService, $translate, currencyService) {
            var vm = this;
            vm.loading = false;
            if ($state.params.invoiceId) {
                vm.loading = true;
                subscriptionResource.getInvoiceDetails({ value: $state.params.invoiceId }, function (data) {
                    vm.order = data;
                    vm.currency = currencyService.find(vm.order.currencySymbol);
                    vm.order.currencySymbol = vm.currency.symbol_native;
                    vm.order.currencyName = $translate.instant("common.currency." + vm.currency.code);
                    if (vm.order.displayCurrency)
                        vm.order.dCurrencySymbol = currencyService.find(vm.order.displayCurrency).symbol;
                    vm.loading = false;
                }, function (error) {
                    messageService.error(error);
                });
            }
            else
                $state.go("main.settings.subscription.billingHistory");
            vm.translateName = function (name, isCountry) {
                if (name) {
                    if (isCountry)
                        return $translate.instant("common.country." + name.replace(/\s+/g, ''));
                    return $translate.instant("common.stateProvince." + name.replace(/\s+/g, ''));
                }
                return "";
            };
            vm.print = function () {
                window.print();
            };
            vm.back = function () {
                if ($state.params.fromState)
                    $state.go($state.params.fromState);
                else
                    $state.go("main.settings.subscription.billingHistory");
            };
        }
    });
}());
